import { render, staticRenderFns } from "./detectionLog.vue?vue&type=template&id=282a3e46&scoped=true&"
import script from "./detectionLog.vue?vue&type=script&lang=ts&"
export * from "./detectionLog.vue?vue&type=script&lang=ts&"
import style0 from "./detectionLog.vue?vue&type=style&index=0&id=282a3e46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282a3e46",
  null
  
)

export default component.exports